/**
 * Some generic events for socket.io
 */
enum GenericEvents {
	JOIN = 'JOIN',
	LEAVE = 'LEAVE',
	GET_ROOMS = 'GET_ROOMS',
	LEAVE_ALL = 'LEAVE_ALL',
	CONNECTION = 'connection',
	DISCONNECTED = 'disconnected',
	DISCONNECT = 'disconnect',
}

export default GenericEvents;